// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bcc35970","609":"de85095d","625":"28975508","649":"d0a4a1d3","652":"4527f782","674":"ef730b96","863":"4a5ca3c6","872":"314e6cdb","900":"5f89728a"}[chunkId] + ".chunk.js";
};